/**
 * @generated SignedSource<<15b1e8d8aaabd35942f8edb37ba20161>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BookingType = "DINING" | "LESSON" | "STANDARD";
export type SlotAvailabilityArgs = {
  bookingType: BookingType;
  facilityId: string;
  instructorIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  lessonTypeId?: string | null | undefined;
};
export type RequestTimeSelectionControlLessonAvailabilityQuery$variables = {
  dateTimeGte: string;
  dateTimeLte: string;
  durationMins: number;
  instructorId: string;
  slotAvailability?: SlotAvailabilityArgs | null | undefined;
};
export type RequestTimeSelectionControlLessonAvailabilityQuery$data = {
  readonly lessonInstructor: {
    readonly availabilitySlots?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly time: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type RequestTimeSelectionControlLessonAvailabilityQuery = {
  response: RequestTimeSelectionControlLessonAvailabilityQuery$data;
  variables: RequestTimeSelectionControlLessonAvailabilityQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dateTimeGte"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dateTimeLte"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "durationMins"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "instructorId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slotAvailability"
},
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "instructorId"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "dateTimeGte",
          "variableName": "dateTimeGte"
        },
        {
          "kind": "Variable",
          "name": "dateTimeLte",
          "variableName": "dateTimeLte"
        },
        {
          "kind": "Variable",
          "name": "durationMins",
          "variableName": "durationMins"
        },
        {
          "kind": "Variable",
          "name": "slotAvailability",
          "variableName": "slotAvailability"
        }
      ],
      "concreteType": "AvailabilitySlotConnection",
      "kind": "LinkedField",
      "name": "availabilitySlots",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AvailabilitySlotEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AvailabilitySlot",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v6/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "time",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StaffProfile",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RequestTimeSelectionControlLessonAvailabilityQuery",
    "selections": [
      {
        "alias": "lessonInstructor",
        "args": (v5/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "RequestTimeSelectionControlLessonAvailabilityQuery",
    "selections": [
      {
        "alias": "lessonInstructor",
        "args": (v5/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v7/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "043f434309c116e7a03e939170295c0f",
    "id": null,
    "metadata": {},
    "name": "RequestTimeSelectionControlLessonAvailabilityQuery",
    "operationKind": "query",
    "text": "query RequestTimeSelectionControlLessonAvailabilityQuery(\n  $instructorId: ID!\n  $dateTimeGte: Datetime!\n  $dateTimeLte: Datetime!\n  $durationMins: Int!\n  $slotAvailability: SlotAvailabilityArgs\n) {\n  lessonInstructor: node(id: $instructorId) {\n    __typename\n    ... on StaffProfile {\n      availabilitySlots(dateTimeGte: $dateTimeGte, dateTimeLte: $dateTimeLte, durationMins: $durationMins, slotAvailability: $slotAvailability) {\n        edges {\n          node {\n            id\n            time\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "b9d539801d38c47fe52dbff3b60b4fb3";

export default node;
